import { createApiRef } from '@backstage/frontend-plugin-api';
import {
  AlertsStatisticsResponse,
  SpmAlertInfo,
} from '@internal/backstage-plugin-devops-spm-common';

export const spmApiRef = createApiRef<SpmApi>().with({
  id: 'spm-api',
  pluginId: 'devops-spm',
});

export interface SpmApi {
  getAlertStatistics(
    accountId: string,
    lastDays: number,
    compression: number,
    types: string[],
  ): Promise<[AlertsStatisticsResponse[], string]>;
  getRecentAlerts(accountId: string, count: number): Promise<SpmAlertInfo[]>;
}
